//frontend/src/components/SearchManagerRequests/Chat/components/AudioRecorder.jsx

import React, { useEffect, useRef, useState } from "react";

export default function AudioRecorder({ onRecorded, onClose }) {
  const [recording, setRecording] = useState(true);
  const [time, setTime] = useState(0);
  const recRef = useRef(null);
  const chunksRef = useRef([]);
  const timerRef = useRef(null);

  useEffect(() => {
    let stream = null;
    (async () => {
      try {
        stream = await navigator.mediaDevices.getUserMedia({ audio: true });
        const rec = new MediaRecorder(stream);
        recRef.current = rec;
        rec.ondataavailable = (e) => {
          if (e.data.size > 0) chunksRef.current.push(e.data);
        };
        rec.onstop = () => {
          stream.getTracks().forEach((t) => t.stop());
          const blob = new Blob(chunksRef.current, {
            type: rec.mimeType || "audio/webm",
          });
          chunksRef.current = [];
          onRecorded?.(blob);
        };
        rec.start();
        timerRef.current = setInterval(() => setTime((t) => t + 1), 1000);
      } catch (err) {
        alert("Не удалось получить доступ к микрофону");
        onClose?.();
      }
    })();

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
      if (recRef.current?.state === "recording") recRef.current.stop();
    };
  }, []);

  const stop = () => {
    if (timerRef.current) clearInterval(timerRef.current);
    if (recRef.current?.state === "recording") recRef.current.stop();
    setRecording(false);
  };

  return (
    <div className="chat-audio-recorder">
      <span className="chat-audio-recorder__dot" />
      <span>Запись {String(Math.floor(time / 60)).padStart(2, "0")}:{String(time % 60).padStart(2, "0")}</span>
      <button type="button" className="chat-audio-recorder__stop" onClick={stop}>
        ■ Стоп
      </button>
    </div>
  );
}